import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux/es/exports";

import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer";

import withParams from "../../../helper/WithParams";

import "../ProductDetails/product-details.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { CurrencyFormatter } from "../../../helper/CurrencyFormatter";

class HistoryDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
    };
  }

  async componentDidMount() {
    // const { params } = this.props;
    console.log(this.props.token);
    const config = {
      headers: { Authorization: `Bearer ${this.props.token}` },
    };
    const url = `${process.env.REACT_APP_HOST_API}/transaction/history/`;
    try {
      const result = await axios.get(url, config);
      const productsArray = result.data.data;
      console.log(productsArray[0]);
      this.setState({
        products: productsArray[0],
      });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const { products } = this.state;
    const { params } = this.props;
    return (
      <div>
        <Navbar page="product" />
        <div className="container details-container">
          <div className="row p-details-row">
            <header className="p-details-header">
              <Link to="/history">History</Link>
              <Link to={`/products/${params.id}`}>
                {" "}
                / {products.product_name}
              </Link>
            </header>
            <section className="left-col-details">
              <div className="details-product-image">
                <img src={`${products.image}`} alt="product-img" />
              </div>
              <div className="product-desc">
                <header className="product-title">
                  {products.product_name}
                </header>
                <p className="product-details">
                  {new Date(products.date).toLocaleDateString("id-ID")}
                </p>
                <div className="delivery-time-product">
                  Buy Method {products.delivery} <br />
                  Total Price
                  {CurrencyFormatter.format(products.total_price)}
                </div>
              </div>
            </section>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.SignInReducer.postUserLoginToken,
  };
};

export default connect(mapStateToProps)(withParams(HistoryDetails));
